import React from 'react';

const Loader = () => {
    return (
        <div className="loader col-12">Loading...</div>
    );
}; 

export default Loader;